export default () => ({
  reportRecommendations: [],
  reportRecommendation: null,
  defaultRecommendation: {
    reportRecommendation: null,
    title: null,
    yearStart: null,
    yearEnd: null,
    systems: [],
    makes: [],
    content: null,
    isChanged: true
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/recommendations/state.js